// **React Imports
import { useState, useCallback, useMemo } from 'react'

export const useFileDragAndDrop = (onFileDropped) => {
  // states
  const [dragActive, setDragActive] = useState(false)

  // handlers
  const handleDrag = useCallback((e) => {
    e.preventDefault()
    e.stopPropagation()
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true)
    } else if (e.type === 'dragleave') {
      setDragActive(false)
    }
  }, [])

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault()
      e.stopPropagation()
      setDragActive(false)

      if (e.dataTransfer?.files && e.dataTransfer.files.length > 0) {
        onFileDropped(e.dataTransfer.files)
      }
    },
    [onFileDropped]
  )

  // variables
  const dragProps = useMemo(
    () => ({
      onDragEnter: handleDrag,
      onDragOver: handleDrag,
      onDragLeave: handleDrag,
      onDrop: handleDrop
    }),
    [handleDrag, handleDrop]
  )

  return { dragActive, dragProps }
}
